import React, { useEffect, useState } from 'react'
import styles from './StoresFilterViewStyles'
import { ScrollView, TouchableOpacity, View, Text } from 'react-native'
import theme from '../../../theme'
import { Feather } from '@expo/vector-icons'
import { TagsModel } from '../customUtils/Components/Models/TagsModel'

export const StoresFilterView = ({ tags, onClickTag }: { tags: TagsModel[]; onClickTag: (tag: TagsModel) => void }) => {
    const [selectedTag, setSelectedTag] = useState(null)

    const onClick = (tag: string, id: number, item: TagsModel) => {
        setSelectedTag(item)
        onClickTag(item)
    }

    return (
        <View>
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                <View style={styles.container}>
                    {tags
                        .sort((a, b) => a.index - b.index)
                        .map((tag, index) => {
                            const isSelected = tag.isSelected

                            return (
                                <StoreTagItem
                                    // key={tag._id}
                                    key={index}
                                    name={tag.title}
                                    id={index}
                                    onClickTag={() => onClick(tag.title, index, tag)}
                                    isSelected={isSelected}
                                />
                            )
                        })}
                </View>
            </ScrollView>
        </View>
    )
}

export const StoreTagItem = ({
    name,
    id,
    onClickTag,
    isSelected,
}: {
    name: string
    id: number
    onClickTag: (tag: string, id: number) => void
    isSelected: boolean
}) => {
    return (
        <View style={styles.containerLabels}>
            {/* <TouchableOpacity>
                <Feather style={{ marginLeft: 12 }} name='search' size={24} color={theme.colors.colorPrimary} />
            </TouchableOpacity> */}
            <TouchableOpacity
                onPress={() => onClickTag(name, id)}
                style={[styles.flatFlagsPrimary, { backgroundColor: isSelected ? theme.colors.colorPrimary : 'white' }]}
            >
                <Text style={isSelected ? styles.flatItemsSelectedPrimary : styles.flatItemsUnselectedPrimary}>{name?.toString().toUpperCase()}</Text>
            </TouchableOpacity>
        </View>
    )
}
